<template>
  <div>
    <el-dialog
      title="绑定手机号"
      :visible.sync="disabled"
      width="700px"
      :modal="false"
      @close="close"
    >
      <el-form
        :model="form"
        ref="formRef"
        size="medium"
        :rules="rules"
        label-position="right"
        label-width="180px"
      >
        <el-form-item label="手机号：" prop="user_id">
          <el-select
            placeholder="请输入"
            :remote-method="remoteMethodCompany"
            :loading="loading"
            filterable
            remote
            reserve-keyword
            clearable
            style="width: 420px"
            v-model="form.user_id"
            @change="changeMobile"
          >
            <el-option
              v-for="item in CallMethod"
              :key="item.user_id"
              :label="item.UserInfo.mobile"
              :value="item.user_id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          style="width: 95%; display: flex; justify-content: flex-end"
        >
          <el-button size="small" @click="close" :loading="btnLoading">
            取 消
          </el-button>
          <el-button
            size="small"
            type="primary"
            @click="Recharge('formRef')"
            :loading="btnLoading"
          >
            确 定
          </el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import { getData } from "@/api/index";
export default {
  props: {
    isShow: Boolean,
    rowData: Object,
    company_id: Number,
  },
  data() {
    return {
      form: {},
      rules: {
        user_id: [
          { required: true, message: "请选择手机号码", trigger: "blur" },
        ],
      },
      disabled: this.isShow,
      btnLoading: false,
      CallMethod: [],
      loading: false,
    };
  },
  async created() {
    this.form = {
      id: this.rowData.id,
      status: 1,
      user_id: "",
      mobile: "",
    };
  },
  methods: {
    changeMobile() {
      for (let i of this.CallMethod) {
        if (i.user_id == this.form.user_id) {
          this.form.mobile = i.UserInfo.mobile;
        }
      }
    },
    async remoteMethodCompany(query) {
      if (query !== "") {
        this.loading = true;
        let res = await getData(
          "company.CompanyUserController/mobilePageAction",
          {
            page: 1,
            pagesize: 20,
            mobile: query,
            is_bind: 2,
            company_id: this.company_id,
          }
        );
        this.loading = false;
        this.CallMethod = res.data.data;
      } else {
        this.CallMethod = [];
      }
    },
    Recharge(form) {
      this.$refs[form].validate(async (valid) => {
        if (valid) {
          this.btnLoading = true;
          let res = await getData(
            "company.CompanyUserController/bindStatusAction",
            this.form
          );
          this.btnLoading = false;
          if (res.code !== 200) return this.$message.error(res.message);
          this.$message.success("绑定成功");
          this.close();
          this.$parent.esarchang();
        } else {
          return false;
        }
      });
    },
    close() {
      this.$emit("close");
    },
  },
};
</script>

<style lang="less" src="@/assets/css/tablecss.less" scoped></style>
